module.exports = __webpack_public_path__ + "static/media/desktop_background_zoomed.78b383a7.png";